import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom'
import { getName } from "../../components/Utils/Common";
import { logout } from "../Auth/Account";
import { FaCog, FaSignOutAlt, FaUsers, FaDesktop, FaChevronDown } from "react-icons/fa";


export const Navigation = () => {
    const history = useHistory()
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    useEffect(() => {
        if (window.location.pathname === "/") {
            history.push("/slides")
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = () => {
            if (isDropdownOpen) setIsDropdownOpen(false)
        }
        document.addEventListener('click', handleClickOutside)
        return () => document.removeEventListener('click', handleClickOutside)
    }, [isDropdownOpen])

    return (
        <div className="">
            <nav className="navbar navbar-expand-lg navbar-dark" style={{ backgroundColor: '#6347D3' }}>

                <Link to="/slides" className="navbar-brand">
                    <img src={process.env.PUBLIC_URL + "/navbar_logo.png"} alt="Micalys Logo" style={{ height: '40px', width: 'auto' }} />
                </Link>

                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarText" style={{ lineHeight: '15px' }}>
                    <ul className="navbar-nav mr-auto" style={{
                        backgroundColor: "transparent",
                        textTransform: "upperCase",
                        fontSize: "13px",
                    }}>
                        <li className="nav-item d-flex align-items-center">
                            <button onClick={() => {
                                const win = window.open('/liveview/', "_blank");
                                win.focus();
                            }} style={{
                                display: 'inline-flex', alignItems: 'center', gap: '6px',
                                background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)',
                                borderRadius: '6px', padding: '6px 14px', color: '#fff',
                                fontSize: '13px', fontWeight: 500, cursor: 'pointer',
                                transition: 'background 0.2s'
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
                            >
                                <FaDesktop /> Remote Microscopy
                            </button>
                        </li>
                    </ul>
                    <ul className="navbar-nav">
                        <li className="nav-item" style={{ position: 'relative' }}>
                            <button
                                className="nav-link btn btn-link"
                                onClick={(e) => { e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen) }}
                                style={{ color: 'rgba(255,255,255,0.9)', display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}
                            >
                                <div style={{
                                    width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#fff',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                                }}>
                                    <span style={{ color: '#6347D3', fontWeight: 600, fontSize: '14px' }}>
                                        {getName()?.charAt(0).toUpperCase() || 'U'}
                                    </span>
                                </div>
                                {getName()}
                                <FaChevronDown style={{ fontSize: '10px', opacity: 0.8, transition: 'transform 0.2s', transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
                            </button>

                            {isDropdownOpen && (
                                <div className="dropdown-menu dropdown-menu-right show" style={{ display: 'block' }}>
                                    <Link className="dropdown-item" to="/groups" onClick={() => setIsDropdownOpen(false)}>
                                        <FaUsers style={{ marginRight: '0.5rem' }} /> My Groups
                                    </Link>
                                    <Link className="dropdown-item" to="/settings" onClick={() => setIsDropdownOpen(false)}>
                                        <FaCog style={{ marginRight: '0.5rem' }} /> Settings
                                    </Link>
                                    <div className="dropdown-divider"></div>
                                    <Link className="dropdown-item" to="#" onClick={() => { setIsDropdownOpen(false); logout(history); }}>
                                        <FaSignOutAlt style={{ marginRight: '0.5rem' }} /> Logout
                                    </Link>
                                </div>
                            )}
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}
